import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fe_errors } from "src/error-management/errors";
import { NAV_TO_HOMEPAGE, NAV_TO_REGISTRATION, SAGA_GUARDS } from "src/navigation";
import { shoot } from "src/redux/actions";
import {
  select_error,
  select_history_item,
  select_logged,
  select_login_token,
} from "src/redux/store";
import { generic_props } from "src/types/--deprecated/containers/generic.types";
import { FailureModal, Loader } from "src/widgets";

const SpidLogin: React.FC<generic_props> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth_code = new URLSearchParams(useLocation().search).get("code");
  const error_code = new URLSearchParams(useLocation().search).get("errorCode");
  const state = new URLSearchParams(useLocation().search).get("state");
  // const oauth_error = new URLSearchParams(useLocation().search).get("error");

  /**
   * Use Selector
   */
  const is_logged = useSelector(select_logged);
  const login_token = useSelector(select_login_token);
  const spid_state = useSelector(select_history_item("spid_state"));
  const spid_captcha = useSelector(select_history_item("spid_captcha"));
  const spid_outcome = useSelector(select_history_item("spid_outcome"));
  const error = useSelector(select_error(SAGA_GUARDS.LOGIN));

  /**
   * Use State
   */
  const [captcha, set_captcha] = useState<string>("");

  /**
   * Use Effect
   */
  useEffect(() => {
    dismiss_error();
  }, []);

  useEffect(() => {
    if (is_logged === true && login_token !== undefined) {
      navigate(NAV_TO_HOMEPAGE);
    }
  }, [is_logged, login_token]);

  useEffect(() => {
    if (spid_outcome != null && spid_outcome !== undefined && spid_outcome !== '') {
      navigate(NAV_TO_REGISTRATION)
    }
  }, [spid_outcome]);

  useEffect(() => {
    if (auth_code) {
      if (spid_captcha !== undefined && spid_state === state) {
        set_captcha(spid_captcha);
        dispatch(shoot.reduce_history_item("spid_state"));
        dispatch(shoot.reduce_history_item("spid_captcha"));
      } else {
        dispatch(shoot.reduce_error(fe_errors["SPID_INVALID_STATE"]));
      }
    } else if (error_code) {
      dispatch(shoot.reduce_error(fe_errors[error_code]));
    }
  }, []);

  useEffect(() => {
    if (error?.code === "") {
      dispatch(shoot.reduce_error(fe_errors["SPID_GENERIC"]));
    }
  }, [error]);

  useEffect(() => {
    if (captcha !== "") {
      spid_login_call();
    }
  }, [captcha]);

  const spid_login_call = () => {
    dismiss_error();
    dispatch(shoot.reduce_ar_access(true));
    dispatch(
      shoot.saga_spid_login({
        token: auth_code,
        captcha: captcha,
      })
    );
  };

  const dismiss_error = () => {
    if (error) {
      dispatch(shoot.reduce_error());
    }
  };

  const on_close = () => {
    dismiss_error();
    navigate(NAV_TO_HOMEPAGE);
  };

  return (
    <>
      <Loader />
      {/* FAILURE MODAL */}
      <FailureModal error={error} on_close={on_close} />
    </>
  );
};

export default SpidLogin;
